// Backend marker for "dealer has no group" (Constants.GROUP_ID_EMPTY).
export const GROUP_ID_EMPTY = 999999;

export const NO_GROUP_LABEL = 'No Group';
export const DEALER_GROUP_PAGE_SIZE = 100;
